module.exports = __webpack_public_path__ + "img/Games.626ef7ea.svg";